import MetricProperty from '@enums/MetricProperty';
import format from '@pkg/utils/numbers/format';
import percent from '@pkg/utils/numbers/percent';
import { EntityMetric } from '@/lib/enums';

export default function tagPercentages(tag, totalHours, comparison) {
  const percentages = {
    hours: null,
    tag: null,
    change: null,
  };

  percentages.tag = percent(tag.__aggregateHours, totalHours, 2);

  const comparisonTag = comparison?.tags.get(tag.uuid);

  if (!comparisonTag) {
    return percentages;
  }

  const comparisonPercentage = percent(
    comparisonTag.hours?.comparison,
    comparison.metrics.activities.hours.comparison,
    2
  );

  percentages.hours = comparisonTag?.hours?.raw
    ? format(
        comparisonTag.hours?.raw,
        MetricProperty[EntityMetric.HOURS].formatOptions
      )
    : null;

  return {
    ...percentages,
    change: Math.round(percentages.tag - comparisonPercentage),
  };
}
